import * as React from 'react';
import { Link } from 'react-router-dom';
import { AppContext, AppContextType } from '../AppContextType';
import { RouteConstants } from '../RouteConstants';
import { Type } from '../Type';

export interface TypeSwitcherProps {
    activeType: Type;
}

export class TypeSwitcher extends React.Component<TypeSwitcherProps> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    public render() {
        const activeType = this.props.activeType;

        return <div className="job-center-type-switcher">
            {this.renderButton(Type.JobVacancy, activeType === Type.JobVacancy)}
            {this.renderButton(Type.Candidate, activeType === Type.Candidate)}
        </div>;
    }

    private renderButton(type: Type, isActive: boolean) {
        const route = type === Type.Candidate ? RouteConstants.Candidate : RouteConstants.JobVacancy;
        const buttonTitle = this.context.i18n.translate(
            type === Type.Candidate ? 'Kandidaten' : 'Stellenangebote'
        );
        const className = 'discreet ' + (isActive ? '-active' : '');

        return <Link role="button" className={className} to={route}>{buttonTitle}</Link>;
    }
}
